import React, { useMemo, useState } from "react";

import ArrowRightBigIcon from "images/icons/arrow-right-big-icon.inline.svg";
import CloseIcon from "images/icons/close-outline.inline.svg";
import AnemoneIllustration from "images/illustrations/Anemone-Illustration-light.inline.svg";

import ContactForm from "../../components/forms/contact";
import Image from "../../components/image";
import Modal from "../../components/shared/modal";
import ModalInPortal from "../../components/shared/modals/modalInPortal";

const ProgramAlumni = ({
  alumniGallery,
  gallery,
  openModal,
  setOpenModal,
  programCode,
  formType = "alumni_request"
}) => {
  const [modalProcessingStatus, setModalProcessingStatus] = useState("");

  const programAlumniGallery = useMemo(
    () => (alumniGallery && alumniGallery.length > 0 ? alumniGallery : gallery),
    [alumniGallery, gallery]
  );

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const hiddenFields = [{ fieldName: "program_id", fieldValue: programCode }];

  return (
    <>
      <section className="alumni-section flex relative mx-auto -mt-210 pt-0 bg-white planet:bg-gray-darker sm:min-h-[36rem] overflow-hidden">
        <AnemoneIllustration className="absolute -bottom-[28vw] -right-[19vw] w-1/2 hidden md:planet:block opacity-15" />
        <div className="flex flex-wrap justify-center w-11/12 gap-10 mx-auto py-14 sm:pb-0 sm:flex-nowrap sm:w-10/12">
          <div className="flex flex-col w-full md:sticky-left-section md:mr-auto md:pr-10">
            <div className="order-1 ">
              <div
                className="program-name font-alice planet:font-body font-normal planet:font-light text-black-lighter planet:text-white text-[26px] sm:text-xlrg-sm"
                dangerouslySetInnerHTML={{
                  __html: "Connect with our alumni"
                }}
              />
              <h6
                className="program-title py-5 planet:!text-gray-generic tab-content_html"
                dangerouslySetInnerHTML={{
                  __html:
                    "Want to connect with some of our past participants about their adventures? Get in touch with hundreds of friendly ambassadors all over the world who would be more than happy to answer any questions. "
                }}
              />
            </div>

            <div className="flex order-3 py-4 program-alumni-callback sm:order-2">
              <button
                className="flex items-center justify-between w-full px-4 font-bold openModalBtn callback-button sm:w-auto bg-white planet:bg-transparent text-black-lighter planet:text-white hover:!bg-transparent hover:!opacity-100"
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                <p className="m-auto text-mob font-bold py-2 pr-3 planet:pr-0 sm:text-base sm:m-0 text-black-lighter planet:text-white planet:hover:text-black-lighter">
                  Speak to our alumni
                </p>
                <ArrowRightBigIcon className="planet:hidden fill-black-lighter" />
              </button>
            </div>

            {openModal && (
              <ModalInPortal
                openModal={openModal}
                modal={
                  <Modal
                    closeModal={handleCloseModal}
                    modalCloseIcon={
                      modalProcessingStatus === "processing" ? (
                        <></>
                      ) : (
                        <CloseIcon className="h-5 fill-white planet:fill-white" />
                      )
                    }
                    modalCloseBtnStyles="flex w-full h-auto flex-col items-end justify-end"
                    modalContentStyles="w-10/12 sm:w-5/12 mx-auto bg-yellow-standard planet:gvi-light-gray-bg rounded-[20px] p-3"
                    modalContainerStyles="w-full sm:w-9/12"
                    modalContent={
                      <div className="px-4 sm:p-8">
                        <ContactForm
                          formType={formType}
                          formHeading="Connect <br/>with our alumni"
                          formStyles="rounded-md bg-yellow-standard planet:gvi-light-gray-bg w-full mx-auto"
                          ctaLabel="Speak to our alumni"
                          hiddenFields={hiddenFields}
                          formTooltipIconStyles={"fill-white planet:fill-white"}
                          formTooltipStyles={
                            "before:bg-white before:text-gray-standard"
                          }
                          additionalFieldContainerClass="xxs:gap-2"
                          iconColor={"text-white fill-white"}
                          contactLabelsClass="text-white"
                          calendlyActive={false}
                          setParentStatus={setModalProcessingStatus}
                        />
                      </div>
                    }
                  />
                }
              />
            )}

            <div className="order-2 pt-8 alumni-grid sm:order-3 rounded">
              <div className="grid grid-flow-col grid-cols-2 grid-rows-2 gap-2 overflow-hidden alumni-gallery sm:grid-rows-1 sm:grid-cols-3 sm:gap-1">
                {programAlumniGallery?.slice(0, 3).map((galleryItem, idx) => (
                  <Image
                    key={`gitem-${idx}`}
                    imageAlt={""}
                    image={galleryItem?.gatsbyImage}
                    imageClass={`${
                      idx === 0
                        ? "row-span-1 col-span-2 sm:col-span-1 rounded-tl-[5px] rounded-tr-[5px] sm:rounded-none"
                        : idx === 1
                          ? "rounded-bl-[5px] sm:rounded-none"
                          : "rounded-br-[5px] sm:rounded-none"
                    } object-cover object-center w-full h-36 sm:h-40`}
                    sourceUrl={galleryItem?.sourceUrl}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProgramAlumni;
